var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-open-chat"},[(_vm.friendType === 1)?_c('ActionOpenChatNormal',{attrs:{"message":_vm.message}}):_vm._e(),(_vm.friendType !== 1)?_c('ActionOpenChatInstant',{attrs:{"message":_vm.message}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }